import React from "react";
import AppModal from "../common/AppModal";
import CreateFeeAllocationForm from "../../forms/CreateFeeAllocationForm";

interface CreateFeeAllocationModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateFeeAllocationModal: React.FC<CreateFeeAllocationModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Allocate Optional Fee"
    width="sm"
    loading={loading}
  >
    <CreateFeeAllocationForm loading={loading} error={error} />
  </AppModal>
);

export default CreateFeeAllocationModal;
